import dayjs from '@/lib/dayjs'
import { ReportingBucketSize } from '@/api/model'

// Must match ReportingBucketRange.MaxYearsBack in the backend
export const MAX_YEARS_BACK = 2
const DATE_FORMAT = 'YYYY-MM-DD'

export interface DashboardDateFilter {
  bucketSize: ReportingBucketSize
  /** `YYYY-MM-DD`, inclusive */
  startDate: string
  /** `YYYY-MM-DD`, inclusive */
  endDate: string
}

export type DateFilterError = 'startAfterEnd' | 'endInFuture' | 'tooFarBack' | 'missing'

export function defaultDashboardDateFilter(today: string = dayjs().format(DATE_FORMAT)): DashboardDateFilter {
  return {
    bucketSize: ReportingBucketSize.Daily,
    startDate: dayjs(today, DATE_FORMAT).subtract(29, 'day').format(DATE_FORMAT),
    endDate: today,
  }
}

/** Earliest allowed start date, also used to disable older days in the date picker */
export function earliestStartDate(today: string = dayjs().format(DATE_FORMAT)): string {
  return dayjs(today, DATE_FORMAT).subtract(MAX_YEARS_BACK, 'year').format(DATE_FORMAT)
}

/** Same rules as the backend, so an invalid range is never sent */
export function validateDashboardDateFilter(
  filter: DashboardDateFilter,
  today: string = dayjs().format(DATE_FORMAT),
): DateFilterError | null {
  if (!filter.startDate || !filter.endDate) return 'missing'
  if (filter.startDate > filter.endDate) return 'startAfterEnd'
  if (filter.endDate > today) return 'endInFuture'
  if (filter.startDate < earliestStartDate(today)) return 'tooFarBack'
  return null
}
